<div class="entity-list-page flex w-full flex-col gap-4">
  <section class="slot-above contents">
    <ng-content select="[slotAbove]" />
  </section>
  <div class="list-container flex w-full items-start gap-4">
    <aside class="slot-start contents">
      <ng-content select="[slotStart]" />
    </aside>
    <div class="list-main w-full min-w-0 flex-1">
      <header class="list-header mb-5 flex items-center justify-between gap-4">
        <h1 class="m-0 font-heading text-3xl leading-tight font-extrabold tracking-tight text-fg">{{ title }}</h1>
        @if (entityConfig.showCreateButton !== false && roleAccess.isActiveSystemRole()) {
          <a uiButton variant="primary" [routerLink]="shellRoutes.commands('manage', entityKey, 'new')">Add new</a>
        }
      </header>
      <lib-dynamic-list
        [listPath]="listPath"
        [extraQueryParams]="extraQueryParams"
        (rowSelect)="onRowSelect($event)"
      />
    </div>
    <aside class="slot-end contents">
      <ng-content select="[slotEnd]" />
    </aside>
  </div>
  <section class="slot-below contents">
    <ng-content select="[slotBelow]" />
  </section>
</div>
